import { render } from "./matchingDetail1.vue?vue&type=template&id=59f7d67b&scoped=true"
import script from "./matchingDetail1.vue?vue&type=script&lang=js"
export * from "./matchingDetail1.vue?vue&type=script&lang=js"

import "./matchingDetail1.vue?vue&type=style&index=0&id=59f7d67b&lang=scss"
import "./matchingDetail1.vue?vue&type=style&index=1&id=59f7d67b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f7d67b"],['__file',"src/views/exhibitionManage/components/matchingDetail1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59f7d67b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59f7d67b', __exports__)) {
    console.log('reload')
    api.reload('59f7d67b', __exports__)
  }
  
  module.hot.accept("./matchingDetail1.vue?vue&type=template&id=59f7d67b&scoped=true", () => {
    console.log('re-render')
    api.rerender('59f7d67b', render)
  })

}


export default __exports__